import {
	req,
	reqF,
	reqNF,
	uploadFile,
	reqFile
} from "./axiosFun";

/**
 * exe菜单
 */
// 保存最近访问菜单
export const SaveRecentlyVisitModule = (params) => {
	return reqF("post", "/api/user/Module/SaveRecentlyVisitModule", params);
};

// 获取最近访问菜单列表
export const GetRecentlyVisitModuleList = (params) => {
	return reqF("post", "/api/user/Module/GetRecentlyVisitModuleList", params);
};

// 获取通讯录
export const GetUserInfoSimpleDropList = (params) => {
	return reqF("post", "/api/user/User/GetUserInfoSimpleDropList", params);
};



// 获取当前任务
export const GetPagePending = (params) => {
	return reqF("post", "/api/basedb/WorkFlow/GetPagePending", params)
};

// 获取流程步骤
export const GetProcessList = (params) => {
	return reqF("post", "/api/basedb/WorkFlow/GetProcessList", params)
};
// 获取流程步骤
export const GetNodeList = (params) => {
	return reqF("post", "/api/basedb/WorkFlow/GetNodeList", params)
};


// 获取数据字典数据列表
export const GetDicDataList = (params) => {
	return reqF("post", "/api/basedb/DicData/GetDicDataList", params);
};
// 保存数据字典
export const SaveDicData = (params) => {
	return reqF("post", "/api/basedb/DicData/SaveDicData", params);
};
// 根据keyId获取数据字典信息
export const GetDicDataByKeyId = (params) => {
	return reqF("post", "/api/basedb/DicData/GetDicDataByKeyId", params);
};
// 删除数据字典
export const DeleteDicData = (params) => {
	return reqF("post", "/api/basedb/DicData/DeleteDicData", params);
};
// 根据Code获取数据字典信息
export const GetDicDataByCode = (params) => {
	return reqF("post", "/api/basedb/DicData/GetDicDataByCode", params);
};
// 获取根据父节点code获取子节点列表
export const GetDicDataListByParentCode = (params) => {
	return reqF("post", "/api/basedb/DicData/GetDicDataListByParentCode", params);
};
// 获取根据父节点code获取子节点列表【包括子节点的子节点】
export const GetAllDicDataListByParentCode = (params) => {
	return reqF("post", "/api/basedb/DicData/GetAllDicDataListByParentCode", params);
};
// 根据父级节点code获取字典树【包括子节点的子节点】 树形
export const GetDicDataTreeByParentCode = (params) => {
	return reqF("post", "/api/basedb/DicData/GetDicDataTreeByParentCode", params);
};
// 获取枚举数据
export const GetEnumListByName = (params) => {
	return reqF("post", "/api/basedb/Enum/GetEnumListByName", params);
};
// 获取附件地址前缀
export const GetFileInfoPath = (params) => {
	return reqF("post", "/api/basedb/FileManager/GetAttachmentPath", params);
};
// 保存文件信息
export const SaveFileInfo = (params) => {
	return reqF("post", "/api/basedb/FileManager/SaveFileInfo", params);
};

// 获取模块树列表
export const GetModuleTreeList = (params) => {
	return reqF("post", "/api/user/Module/GetModuleTreeList", params);
};
// 获取模块详情
export const GetModuleInfoByKeyId = (params) => {
	return reqF("post", "/api/user/Module/GetModuleInfoByKeyId", params);
};
// 保存模块
export const SaveModule = (params) => {
	return reqF("post", "/api/user/Module/SaveModule", params);
};
// 删除模块
export const DeleteModuleInfo = (params) => {
	return reqF("post", "/api/user/Module/DeleteModuleInfo", params);
};


// 获取角色列表
export const GetRoleInfoList = (params) => {
	return reqF("post", "/api/user/Role/GetRoleInfoList", params);
};
// 获取角色信息详情
export const GetRoleInfoByKeyId = (params) => {
	return reqF("post", "/api/user/Role/GetRoleInfoByKeyId", params);
};
// 保存角色信息
export const SaveRoleInfo = (params) => {
	return reqF("post", "/api/user/Role/SaveRoleInfo", params);
};
// 删除角色信息
export const DeleteRoleInfo = (params) => {
	return reqF("post", "/api/user/Role/DeleteRoleInfo", params);
};
// 获取角色关联的人员名单
export const GetRoleLinkUserInfoList = (params) => {
	return reqF("post", "/api/user/Role/GetRoleLinkUserInfoList", params);
};
// 获取未关联角色的用户列表
export const GetNoRoleLinkUserInfoList = (params) => {
	return reqF("post", "/api/user/Role/GetNoRoleLinkUserInfoList", params);
};
// 保存角色关联的用户信息
export const SaveRoleLinkUserInfo = (params) => {
	return reqF("post", "/api/user/Role/SaveRoleLinkUserInfo", params);
};
// 获取角色关联的模块信息
export const GetRoleLinkModuleList = (params) => {
	return reqF("post", "/api/user/Role/GetRoleLinkModuleList", params);
};
// 保存角色关联模块信息
export const SaveRoleLinkModuleList = (params) => {
	return reqF("post", "/api/user/Role/SaveRoleLinkModuleList", params);
};
// 获取角色的权限的树级数据
export const GetRoleModuleTreeList = (params) => {
	return reqF("post", "/api/user/Role/GetRoleModuleTreeList", params);
};
// 角色绑定下拉框
export const GetRoleInfoDropList = (params) => {
	return reqF("post", "/api/user/Role/GetRoleInfoDropList", params);
};

// 重置密码
export const ResetUserPassword = (params) => {
	return reqF("post", "/api/user/User/ResetUserPassword", params);
};
// 人员信息列表
export const GetUserInfoList = (params) => {
	return reqF("post", "/api/user/User/GetUserInfoList", params);
};
// 人员详情
export const GetUserInfoByKeyId = (params) => {
	return reqF("post", "/api/user/User/GetUserInfoByKeyId", params);
};
// 保存用户信息
export const SaveUserInfo = (params) => {
	return reqF("post", "/api/user/User/SaveUserInfo", params);
};
// 删除用户信息
export const DeleteUserInfo = (params) => {
	return reqF("post", "/api/user/User/DeleteUserInfo", params);
};
// 修改人员照片
export const UpdateUserPhoto = (params) => {
	return reqF("post", "/api/user/User/UpdateUserPhoto", params);
};
// 修改人员签字图片
export const UpdateUserSignature = (params) => {
	return reqF("post", "/api/user/User/UpdateUserSignature", params);
};
// 人员下拉
export const GetUserInfoDropList = (params) => {
	return reqF("post", "/api/user/User/GetUserInfoDropList", params);
};
// 无角色人员下拉
export const GetNoRoleUserInfoDropList = (params) => {
	return reqF("post", "/api/user/User/GetNoRoleUserInfoDropList", params);
};
// 有角色人员下拉
export const GetRoleUserInfoDropList = (params) => {
	return reqF("post", "/api/user/User/GetRoleUserInfoDropList", params);
};
// 工厂人员下拉
export const GetDeptUserInfoDropList = (params) => {
	return reqF("post", "/api/user/User/GetDeptUserInfoDropList", params);
};
/**工作流 */
// 列表
export const GetStructureDataList = (params) => {
	return reqF("post", "/api/basedb/WorkFlow/GetStructureDataList", params)
};
// 添加编辑
export const SaveStructure = (params) => {
	return reqF("post", "/api/basedb/WorkFlow/UpdateStructure", params)
};
// 修改工作流状态
export const UpdateStructureStatus = (params) => {
	return reqF("post", "/api/basedb/WorkFlow/UpdateStructureStatus", params)
};
// 删除
export const DeleteStructure = (params) => {
	return reqF("post", "/api/basedb/WorkFlow/DeleteStructure", params)
};
// 业务下拉
export const GetWorkFlowBusinessList = (params) => {
	return reqF("post", "/api/basedb/WorkFlow/GetWorkFlowBusinessList", params)
};
// 业务列表
export const GetWorkFlowBusinessPageList = (params) => {
	return reqF("post", "/api/basedb/WorkFlow/GetWorkFlowBusinessPageList", params)
};
// 业务保存
export const SaveWorkFlowBusiness = (params) => {
	return reqF("post", "/api/basedb/WorkFlow/SaveWorkFlowBusiness", params)
};
// 业务删除
export const DeleteWorkFlowBusiness = (params) => {
	return reqF("post", "/api/basedb/WorkFlow/DeleteWorkFlowBusiness", params)
};



// 获取焊工数据列表
export const GetWelderList = (params) => {
	return reqF("post", "/api/user/User/GetWelderList", params);
};

// 获取焊接人员列表
export const GetWeldUserListForPage = (params) => {
	return reqF("post", "/api/user/User/GetWeldUserListForPage", params);
};

// 保存我的应用
export const SaveMyModuleInfoRecord = (params) => {
	return reqF("post", "/api/user/Module/SaveMyModuleInfoRecord", params);
};

// 获取我的应用
export const GetMyModuleInfoRecordList = (params) => {
	return reqF("post", "/api/user/Module/GetMyModuleInfoRecordList", params);
};

// 删除我的应用
export const DeleteMyModuleInfoRecord = (params) => {
	return reqF("post", "/api/user/Module/DeleteMyModuleInfoRecord", params);
};

// 获取通知消息列表 查询
export const GetMessageDataList = (params) => {
	return reqF("post", "/api/sysConfig/Message/GetMessageDataList", params);
};

// 接收（阅读）消息
export const ReadMessage = (params) => {
	return reqF("post", "/api/sysConfig/Message/ReadMessage", params);
};

// 删除消息
export const DelMessage = (params) => {
	return reqF("post", "/api/sysConfig/Message/DelMessage", params);
};





/**
 * 新的
 */
// 获取附件地址前缀
export const GetAttachmentPath = (params) => {
	return reqF("post", "/api/sysConfig/FileManager/GetAttachmentPath", params);
};

// 下载文件
export const DownLoadFile = (params) => {
	return reqFile("get", "/api/sysConfig/DownLoad/DownLoadFile", params);
};

/**
 * 焊接资质管理
 */
// 获取资质信息数据列表
export const GetQualificationInfoList = (params) => {
	return reqF("post", "/api/sysConfig/QualificationInfo/GetQualificationInfoList", params);
};

// 保存资质信息
export const SaveQualificationInfo = (params) => {
	return reqF("post", "/api/sysConfig/QualificationInfo/SaveQualificationInfo", params);
};

// 删除资质信息
export const DeleteQualificationInfo = (params) => {
	return reqF("post", "/api/sysConfig/QualificationInfo/DeleteQualificationInfo", params);
};

// 获取资质信息详细
export const GetQualificationInfoByKeyId = (params) => {
	return reqF("post", "/api/sysConfig/QualificationInfo/GetQualificationInfoByKeyId", params);
};

// 获取资质信息下拉数据列表
export const GetQualificationInfoDropDownList = (params) => {
	return reqF("post", "/api/sysConfig/QualificationInfo/GetQualificationInfoDropDownList", params);
};


// 获取焊工资质关联信息数据列表
export const GetUQLinkList = (params) => {
	return reqF("post", "/api/sysConfig/QualificationInfo/GetUQLinkList", params);
};

// 保存焊工关联资质信息
export const SaveUQLink = (params) => {
	return reqF("post", "/api/sysConfig/QualificationInfo/SaveUQLink", params);
};

// 获取焊工资质关联信息详细
export const GetUQLinkInfoByKeyId = (params) => {
	return reqF("post", "/api/sysConfig/QualificationInfo/GetUQLinkInfoByKeyId", params);
};
// 删除焊工关联资质信息
export const DeleteUQLink = (params) => {
	return reqF("post", "/api/sysConfig/QualificationInfo/DeleteUQLink", params);
};

// 获取临期/到期焊工资质信息
export const GetUserDyingPeriodUQLink = (params) => {
	return reqF("post", "/api/sysConfig/QualificationInfo/GetUserDyingPeriodUQLink", params);
};

// 获取焊工资质台账列表
export const GetWelderQualificationList = (params) => {
	return reqF("post", "/api/sysConfig/QualificationInfo/GetWelderQualificationList", params);
};

// 获取焊工资质台账导出数据
export const GetWelderQualificationExport = (params) => {
	return reqF("post", "/api/sysConfig/QualificationInfo/GetWelderQualificationExport", params);
};



/**
 * 系统业务配置
 */

// 分页获取系统业务配置列表
export const GetSystemBusinessConfigList = (params) => {
	return reqF("post", "/api/sysConfig/SysBusinessConfig/GetSystemBusinessConfigList", params);
};

// 保存系统业务配置
export const SaveSystemBusinessConfig = (params) => {
	return reqF("post", "/api/sysConfig/SysBusinessConfig/SaveSystemBusinessConfig", params);
};

// 删除系统业务配置信息
export const DelSystemBusinessConfig = (params) => {
	return reqF("post", "/api/sysConfig/SysBusinessConfig/DelSystemBusinessConfig", params);
};

// 获取系统业务配置详情
export const GetSystemBusinessConfigDetail = (params) => {
	return reqF("post", "/api/sysConfig/SysBusinessConfig/GetSystemBusinessConfigDetail", params);
};
// 根据编码获取系统业务配置详情
export const GetSystemBusinessConfigDetailByCode = (params) => {
	return reqF("post", "/api/sysConfig/SysBusinessConfig/GetSystemBusinessConfigDetailByCode", params);
};


/**
 * 移动端菜单
 */

// 获取APP菜单列表
export const GetAppMenuList = (params) => {
	return reqF("post", "/api/sysConfig/AppMenu/GetAppMenuList", params);
};
// 保存APP菜单
export const SaveAppMenu = (params) => {
	return reqF("post", "/api/sysConfig/AppMenu/SaveAppMenu", params);
};
// 删除APP菜单信息
export const DelAppMenu = (params) => {
	return reqF("post", "/api/sysConfig/AppMenu/DelAppMenu", params);
};
// 获取APP菜单详情
export const GetAppMenuDetail = (params) => {
	return reqF("post", "/api/sysConfig/AppMenu/GetAppMenuDetail", params);
};

// 获取用户拥有的APP权限列表
export const GetUserHasAppMenu = (params) => {
	return reqF("post", "/api/sysConfig/AppMenu/GetUserHasAppMenu", params);
};

// 设置APP菜单是否显示和隐藏
export const SetAppMenuIsShow = (params) => {
	return reqF("post", "/api/sysConfig/AppMenu/SetAppMenuIsShow", params);
};


/**
 * 系统日志
 */
//获取系统操作日志数据列表
export const GetSystemOperationLogList = (params) => {
	return reqF("post", "/api/sysConfig/SystemOperationLog/GetSystemOperationLogList", params);
};
//根据业务主键id获取操作日志列表
export const GetSystemOperationLogListByBusinessKeyId = (params) => {
	return reqF("post", "/api/sysConfig/SystemOperationLog/GetSystemOperationLogListByBusinessKeyId", params);
};


/**
 * 系统通知
 */
//获取系统通知列表
export const GetSystemNoticeList = (params) => {
	return reqF("post", "/api/sysConfig/SystemNotice/GetSystemNoticeList", params);
};
//获取系统通知显示列表
export const GetSystemNoticeListForShow = (params) => {
	return reqF("post", "/api/sysConfig/SystemNotice/GetSystemNoticeListForShow", params);
};

//保存系统通知
export const SaveSystemNotice = (params) => {
	return reqF("post", "/api/sysConfig/SystemNotice/SaveSystemNotice", params);
};

//删除系统通知
export const DeleteSystemNotice = (params) => {
	return reqF("post", "/api/sysConfig/SystemNotice/DeleteSystemNotice", params);
};

//获取系统通知详情
export const GetSystemNoticeDetail = (params) => {
	return reqF("post", "/api/sysConfig/SystemNotice/GetSystemNoticeDetail", params);
};

//设置系统通知是否显示
export const UpdateSystemNoticeShow = (params) => {
	return reqF("post", "/api/sysConfig/SystemNotice/UpdateSystemNoticeShow", params);
};

//设置系统通知是否置顶
export const UpdateSystemNoticeTop = (params) => {
	return reqF("post", "/api/sysConfig/SystemNotice/UpdateSystemNoticeTop", params);
};
//添加web系统更新
export const WebSystemUpdate = (params) => {
	return reqF("post", "/api/sysConfig/SystemUpdate/WebSystemUpdate", params);
};
//添加app系统更新
export const AppSystemUpdate = (params) => {
	return reqF("post", "/api/sysConfig/SystemUpdate/AppSystemUpdate", params);
};
//获取系统更新历史列表
export const GetSystemUpdateHistoryList = (params) => {
	return reqF("post", "/api/sysConfig/SystemUpdate/GetSystemUpdateHistoryList", params);
};
//保存单个文件
export const SaveSingleAttachment = (params) => {
	return reqF("post", "/api/sysConfig/FileManager/SaveSingleAttachment", params);
};
//断点续传
export const Upload = (params, queryValue) => {
	return uploadFile("post", `/api/sysConfig/FileManager/Upload?FileTypeId=${queryValue.FileTypeId}&chunkIndex=${queryValue.chunkIndex}&totalChunks=${queryValue.totalChunks}&fileName=${queryValue.fileName}`, params)
};


//改变消息状态
export const updateCustomStatus = (params) => {
	return reqF("post", `/api/chat/message/private/updateCustomStatus`, params)
};

//更新消息自定义状态
export const updateCustomStatusByBatchNo = (params) => {
	return reqF("post", `/api/chat/message/private/updateCustomStatusByBatchNo`, params)
};
//获取资质信息下拉数据列表  包含缩写和操作项目
export const GetQualificationDropDownList = (params) => {
	return reqF("post", `/api/sysConfig/QualificationInfo/GetQualificationDropDownList`, params)
};
// 获取人员在指定类型的组织架构中的组织架构信息 
export const GetUserInOrgs = (params) => {
	return reqF("post", "/api/sysConfig/Organization/GetUserInOrgs", params);
};